import { LocationObject } from "./types";

export const ALL_STATES: Record<string, LocationObject> = {
  "news-in-delhi": { label: "Delhi", inline_label: "Delhi", value: "DL", language: "Hindi", lang_string: "हिन्दी", label_string: "दिल्ली" },
  "news-in-haryana": { label: "Haryana", inline_label: "Haryana", value: "HR", language: "Hindi", lang_string: "हिन्दी", label_string: "हरियाणा" },
  "news-in-uttar-pradesh": { label: "Uttar Pradesh", inline_label: "Uttar Pradesh", value: "UP", language: "Hindi", lang_string: "हिन्दी", label_string: "उत्तर प्रदेश" },
  "news-in-bihar": { label: "Bihar", inline_label: "Bihar", value: "BR", language: "Hindi", lang_string: "हिन्दी", label_string: "बिहार" },
  "news-in-chhattisgarh": { label: "Chhattisgarh", inline_label: "Chhattisgarh", value: "CG", language: "Hindi", lang_string: "हिन्दी", label_string: "छत्तीसगढ़" },
  "news-in-madhya-pradesh": { label: "Madhya Pradesh", inline_label: "Madhya Pradesh", value: "MP", language: "Hindi", lang_string: "हिन्दी", label_string: "मध्य प्रदेश" },
  "news-in-rajasthan": { label: "Rajasthan", inline_label: "Rajasthan", value: "RJ", language: "Hindi", lang_string: "हिन्दी", label_string: "राजस्थान" },
  "news-in-jharkhand": { label: "Jharkhand", inline_label: "Jharkhand", value: "JH", language: "Hindi", lang_string: "हिन्दी", label_string: "झारखंड" },
  "news-in-himachal-pradesh": { label: "Himachal Pradesh", inline_label: "Himachal Pradesh", value: "HP", language: "Hindi", lang_string: "हिन्दी", label_string: "हिमाचल प्रदेश" },
  "news-in-uttarakhand": { label: "Uttarakhand", inline_label: "Uttarakhand", value: "UK", language: "Hindi", lang_string: "हिन्दी", label_string: "उत्तराखंड" },
  "news-in-punjab": { label: "Punjab", inline_label: "Punjab", value: "PB", language: "Punjabi", lang_string: "ਪੰਜਾਬੀ", label_string: "ਪੰਜਾਬ" },  
  "news-in-andhra-pradesh": { label: "Andhra Pradesh", inline_label: "Andhra Pradesh", value: "AP", language: "Telugu", lang_string: "తెలుగు", label_string: "ఆంధ్ర ప్రదేశ్" },
  "news-in-telangana": { label: "Telangana", inline_label: "Telangana", value: "TS", language: "Telugu", lang_string: "తెలుగు", label_string: "తెలంగాణ" },
  "news-in-tamil-nadu": { label: "Tamil Nadu", inline_label: "Tamil Nadu", value: "TN", language: "Tamil", lang_string: "தமிழ்", label_string: "தமிழ்நாடு" },
  "news-in-karnataka": { label: "Karnataka", inline_label: "Karnataka", value: "KA", language: "Kannada", lang_string: "ಕನ್ನಡ", label_string: "ಕರ್ನಾಟಕ" },
  "news-in-maharashtra": { label: "Maharashtra", inline_label: "Maharashtra", value: "MH", language: "Marathi", lang_string: "मराठी", label_string: "महाराष्ट्र" },
  "news-in-assam": { label: "Assam", inline_label: "Assam", value: "AS", language: "Assamese", lang_string: "অসমীয়া", label_string: "অসম" },
  "news-in-west-bengal": { label: "West Bengal", inline_label: "West Bengal", value: "WB", language: "Bengali", lang_string: "বাংলা", label_string: "পশ্চিমবঙ্গ" },
  "news-in-tripura": { label: "Tripura", inline_label: "Tripura", value: "TR", language: "Bengali", lang_string: "বাংলা", label_string: "ত্রিপুরা" },
  "news-in-gujarat": { label: "Gujarat", inline_label: "Gujarat", value: "GJ", language: "Gujarati", lang_string: "ગુજરાતી", label_string: "ગુજરાત" },
  "news-in-odisha": { label: "Odisha", inline_label: "Odisha", value: "OD", language: "Odia", lang_string: "ଓଡ଼ିଆ", label_string: "ଓଡିଶା" },
  "news-in-kerala": { label: "Kerala", inline_label: "Kerala", value: "KL", language: "Malayalam", lang_string: "മലയാളം", label_string: "കേരളം" },
 };

export const PROXIMITY_STATES: Record<string, string[]> = {
  DK: ['delhi'],
  BR: ["jharkhand", "chhattisgarh", "madhya-pradesh", "uttar-pradesh", "delhi"],
  JH: ["bihar", "chhattisgarh", "uttar-pradesh", "madhya-pradesh", "delhi"],
  MP: ["rajasthan", "chhattisgarh", "uttar-pradesh", "delhi"],
  CG: ["madhya-pradesh", "jharkhand", "uttar-pradesh", "bihar", "delhi"],
  UP: ["delhi", "haryana", "madhya-pradesh", "uttarakhand", "delhi"],
  RJ: ["haryana", "madhya-pradesh", "uttar-pradesh", "haryana", "delhi"],
  HP: ["uttarakhand", "haryana", "uttar-pradesh", "delhi"],
  UK: ["himachal-pradesh", "haryana", "uttar-pradesh", "delhi"],
  HR: ["delhi", "uttar-pradesh", "rajasthan"],
  OD: [],
  AP: ["telangana"],
  TS: ["andhra-pradesh"],
  WB: ["tripura", "assam"],
  AS: ["west-bengal", "tripura"],
  GJ: [],
  TR: ["west-bengal", "assam"],
  MH: [],
  KA: [],
  TN: [],
  PB: [],
  KL: [],
  DL: [
    "uttar-pradesh",
    "haryana",
    "rajasthan",
    "madhya-pradesh",
    "himachal-pradesh",
    "uttarakhand",
    "chhattisgarh",
    "jharkhand",
  ],
};

export const STATE_CODE_TO_SLUG: Record<string, string> = Object.entries(ALL_STATES).reduce(
  (acc, [key, value]) => {
    acc[value.value] = key;
    return acc;
  },
  {} as Record<string, string>
);